import { Textarea } from "../../../components/ui/textarea";
import { Button } from "../../../components/ui/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addQuestionWithDto, fetchAllDescriptions } from "../../../api/reportsApi";
import { EditableReportQuestion } from "../../../types/Rows";
import AddItemWithExistingPicker, { InputType } from "../AddItemWithExistingPicker";
import { deleteQuestion } from "../../../api/templatesApi";
import { PlusIcon } from "../../../types/PlusIcon";

export const SelectDefault = ({
  value,
  setValue,
  disabled = false,
}: {
  value: string;
  setValue: (val) => void;
  disabled?: boolean;
}) => {
  return (
    <div className="p-1">
      <select
        value={value}
        disabled={disabled}
        onChange={(e) => setValue(e.target.value)}
        className="w-full rounded-[var(--sc-radius-md)] border border-[var(--sc-border)] bg-[var(--sc-surface)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--sc-amber)]"
      >
        <option value="yes">Tak</option>
        <option value="no">Nie</option>
        <option value="na">N/A</option>
      </select>
    </div>
  );
};
export const Question = ({
  index,
  input,
  description,
  setDescription,
  templateId,
  isBlank,
  setIsBlank,
  isDirectAnswer,
  setIsDirectAnswer,
  childrenRequiredAnswer,
  setChildrenRequiredAnswer,
  sectionId,
  isLocked,
  depth,
}: {
  index: number;
  input: EditableReportQuestion;
  description: string;
  setDescription: (val: string) => void;
  templateId: string;
  isBlank: boolean;
  setIsBlank: (val: boolean) => void;
  isDirectAnswer: boolean;
  setIsDirectAnswer: (val: boolean) => void;
  childrenRequiredAnswer: string;
  setChildrenRequiredAnswer: (val: string) => void;
  sectionId: string;
  isLocked: boolean;
  depth: number;
}) => {
  const queryClient = useQueryClient();

  const { mutate: deleteItem } = useMutation(
    async ({ templateId, value }: { templateId: string; value: string }) =>
      deleteQuestion(templateId, value),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(["Templates", templateId, "Questions"]);
      },
    }
  );

  const { mutate: addItem } = useMutation(
    async ({
      templateId,
      sectionId,
      question,
    }: {
      templateId: string;
      sectionId: string;
      question: {
        descriptionId: string;
        parentId: string;
        weight: number;
        isBlank: boolean;        isDirectAnswer: boolean;        sectionId: string;
        requiredAnswerToBeVisible?: string;
      };
    }) => addQuestionWithDto(templateId, sectionId, question),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(["Templates", templateId, "Questions"]);
      },
    }
  );

  return (
    <>
      <div
        className={`flex gap-3 flex-row justify-between
                  max-h-50
                  m-1`}
      >
        {/* <div className={`p-${}`}></div> */}
        <div className={`col-span-${1}`}>
          <input
            type="number"
            style={{ width: "100px" }}
            // value={weight}
            // onChange={(e) => setWeight(Number.parseInt(e.target.value) || 0)}
          />
        </div>
        <div style={{ width: "80%" }}>
          <div className={`ml-${3 * depth}`}></div>
          <div style={{ width: "100%" }}>
            <Textarea
              disabled={true}
              placeholder="Opis pytania"
              className="border w-100"
              // rows={8}
              style={{ height: "100%", width: "100%" }}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="flex flex-row">
          {depth > 0 && (
            <div className={`ml-${2 + depth - 1}`}>
              <SelectDefault
                value={childrenRequiredAnswer}
                setValue={setChildrenRequiredAnswer}
                disabled={isLocked}
              />
            </div>
          )}

          <div className="pl-2">
            <label title="isBlank" className="flex items-center gap-1.5 text-sm cursor-pointer">
              <input
                type="checkbox"
                defaultChecked={isBlank}
                disabled={isLocked}
                onChange={() => setIsBlank(!isBlank)}
                name={"checkboxisblank-" + input.id}
                className="h-4 w-4 rounded border-[var(--sc-border)] accent-[var(--sc-amber)]"
              />{" "}
              Bez odpowiedzi Tak/Nie
            </label>
          </div>
          <div className="pl-2">
            <label title="isDirectAnswer" className="flex items-center gap-1.5 text-sm cursor-pointer">
              <input
                type="checkbox"
                defaultChecked={isDirectAnswer}
                disabled={isLocked}
                onChange={() => setIsDirectAnswer(!isDirectAnswer)}
                name={"checkboxisdirectanswer-" + input.id}
                className="h-4 w-4 rounded border-[var(--sc-border)] accent-[var(--sc-amber)]"
              />{" "}
              Bezpośredni komentarz
            </label>
          </div>
          <div className="flex justify-around h-12">
            {depth < 2 && !isLocked && (
              <AddItemWithExistingPicker
                text="Dodaj dziecko"
                inputType={InputType.PICKFROMEXISTING}
                saveNew={(value) => {
                  addItem({
                    templateId: templateId,
                    sectionId: sectionId,
                    question: {
                      descriptionId: value,
                      parentId: input.id,
                      weight: (input.children?.length || 0) + 1,
                      isBlank: isBlank,
                      isDirectAnswer: isDirectAnswer,
                      sectionId: sectionId,
                      requiredAnswerToBeVisible: childrenRequiredAnswer,
                    },
                  });
                }}
                saveExisting={(questionId: string) => {
                  addItem({
                    templateId: templateId,
                    sectionId: sectionId,
                    question: {
                      descriptionId: questionId,
                      parentId: input.id,
                      weight: (input.children?.length || 0) + 1,
                      isBlank: isBlank,
                      isDirectAnswer: isDirectAnswer,
                      sectionId: sectionId,
                      requiredAnswerToBeVisible: childrenRequiredAnswer,
                    },
                  });
                }}
                items={() =>
                  fetchAllDescriptions().then((items) =>
                    items.map((x) => ({
                      id: x.id,
                      name: x.description,
                    }))
                  )
                }
              >
                <PlusIcon />
              </AddItemWithExistingPicker>
            )}
            {!isLocked && (
              <Button
                variant="ghost"
                aria-label="Usuń pytanie"
                title="Usuń pytanie"
                onClick={() => {
                  const msg = input.children?.length
                    ? `Usunąć pytanie razem z pytaniami zależnymi (${input.children.length})?`
                    : "Usunąć pytanie z szablonu?";
                  if (window.confirm(msg)) deleteItem({ templateId: templateId, value: input.id });
                }}
              >
                x
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
